import { getOpeningHoursForStoreDate, parseTimeToMinutes } from './appointmentBookingUtils';

export const AGENDA_HOUR_LABEL_INTERVAL_MINUTES = 60;
const DEFAULT_EARLIEST_MINUTES = 9 * 60;
const DEFAULT_LATEST_MINUTES = 19 * 60;
const DAY_MINUTES = 24 * 60;

const snapBoundsToHourLabels = (earliest, latest) => {
  let snappedEarliest = Math.floor(earliest / AGENDA_HOUR_LABEL_INTERVAL_MINUTES) * AGENDA_HOUR_LABEL_INTERVAL_MINUTES;
  let snappedLatest = Math.ceil(latest / AGENDA_HOUR_LABEL_INTERVAL_MINUTES) * AGENDA_HOUR_LABEL_INTERVAL_MINUTES;

  snappedEarliest = Math.max(0, snappedEarliest);
  snappedLatest = Math.min(DAY_MINUTES, snappedLatest);

  if (snappedLatest <= snappedEarliest) {
    snappedLatest = Math.min(DAY_MINUTES, snappedEarliest + AGENDA_HOUR_LABEL_INTERVAL_MINUTES);
  }

  return { earliest: snappedEarliest, latest: snappedLatest };
};

export const getStoreHoursBounds = (days, store, extraPeriods = []) => {
  let earliest = DAY_MINUTES;
  let latest = 0;

  (days || []).forEach((day) => {
    const opening = getOpeningHoursForStoreDate(store, day);
    (opening?.periods || []).forEach((period) => {
      earliest = Math.min(earliest, parseTimeToMinutes(period.from));
      latest = Math.max(latest, parseTimeToMinutes(period.to));
    });
  });

  (extraPeriods || []).forEach((period) => {
    earliest = Math.min(earliest, parseTimeToMinutes(period.from));
    latest = Math.max(latest, parseTimeToMinutes(period.to));
  });

  if (latest <= earliest) {
    earliest = DEFAULT_EARLIEST_MINUTES;
    latest = DEFAULT_LATEST_MINUTES;
  }

  return snapBoundsToHourLabels(earliest, latest);
};

const readEventRange = (period) => {
  if (!period?.from || !period?.to) {
    return null;
  }

  const from = parseTimeToMinutes(period.from);
  const to = parseTimeToMinutes(period.to);
  if (to <= from) {
    return null;
  }

  return { from, to };
};

export const extendBoundsWithCalendarEvents = (bounds, calendarColumns = []) => {
  let earliest = bounds.earliest;
  let latest = bounds.latest;

  calendarColumns.forEach((column) => {
    (column.appointments || []).forEach((appointment) => {
      const range = readEventRange(appointment.displayPeriod || appointment.period);
      if (!range) {
        return;
      }

      earliest = Math.min(earliest, range.from);
      latest = Math.max(latest, range.to);
    });

    (column.timeOffs || []).forEach((timeOff) => {
      const range = readEventRange(timeOff?.period);
      if (!range) {
        return;
      }

      earliest = Math.min(earliest, range.from);
      latest = Math.max(latest, range.to);
    });
  });

  return snapBoundsToHourLabels(earliest, latest);
};

export const getAgendaVisibleBounds = (days, store, calendarColumns = [], extraPeriods = []) => (
  extendBoundsWithCalendarEvents(getStoreHoursBounds(days, store, extraPeriods), calendarColumns)
);
